export { default } from './getColorClass'
